import { Button } from '@mui/material';
import { useCompareStore } from './useCompareStore';
import { SourceId } from '../CanvasView/CanvasView';
import { ExpandMore } from '@mui/icons-material';

export const CanvasItemId = ({
  id,
  sourceId,
}: {
  id: string | number;
  sourceId: SourceId;
}) => {
  const { setIsScanSelectorOpen } = useCompareStore();

  const handleClick = () => {
    if (sourceId === 'primary') {
      setIsScanSelectorOpen('primary');
    } else {
      setIsScanSelectorOpen('secondary');
    }
  };

  return (
    <div
      style={{
        position: 'absolute',
        top: 8,
        right: 8,
        padding: '4px 8px',
        fontSize: '12px',
        fontWeight: 'bold',
      }}
    >
      <Button
        variant='outlined'
        size='small'
        onClick={handleClick}
        endIcon={<ExpandMore />}
      >
        Record ID: {id}
      </Button>
    </div>
  );
};
